import { getDistributionZones } from '../../../../../../../../Module/graphQL/PathFinder/pathFinderGQL'

const formatCitiesSettings = (citiesSettings, countrySettings) => {
  return citiesSettings.reduce(
    (acc, item) => {
      let valueFlyerPackD2d = item.flyerPackD2d
      let valueFlyerPackH2h = item.flyerPackH2h

      if (typeof item.flyerPackD2d === 'object') {
        valueFlyerPackD2d = item.flyerPackD2d && item.flyerPackD2d.value
      }

      if (typeof item.flyerPackH2h === 'object') {
        valueFlyerPackH2h = item.flyerPackH2h && item.flyerPackH2h.value
      }

      const errorFlyerPackD2d = valueFlyerPackD2d
        ? valueFlyerPackD2d < 100
        : false
      const errorFlyerPackH2h = valueFlyerPackH2h
        ? valueFlyerPackH2h < 100
        : false

      if (errorFlyerPackD2d || errorFlyerPackH2h) {
        acc.error = 'Flyer Pack must be >= 100'
      }
      if (
        item.baPayout === 0 ||
        (!countrySettings.baPayout && item.baPayout === null)
      ) {
        acc.error =
          'The BA payout per mission value should always be greater than 0.'
      }

      acc.formattedCitiesSettings.push({
        ...item,
        flyerPackD2d: {
          error: errorFlyerPackD2d,
          value: valueFlyerPackD2d,
        },
        flyerPackH2h: {
          error: errorFlyerPackD2d,
          value: valueFlyerPackH2h,
        },
      })
      return acc
    },
    { formattedCitiesSettings: [], error: false },
  )
}

const checkDistributionZonesInCity = async (cityId, key) => {
  const distributionZonesResponse = await getDistributionZones(cityId)
  let error = true

  if (distributionZonesResponse) {
    const distributionZonesParsed = await distributionZonesResponse.json()
    if (
      distributionZonesParsed &&
      distributionZonesParsed.data &&
      distributionZonesParsed.data.distributionZones
    ) {
      const d2dDistributionZones = distributionZonesParsed.data.distributionZones.d2d.filter(
        zone => zone.areaType === 'distribution',
      )
      const h2hDistributionZones = distributionZonesParsed.data.distributionZones.h2h.filter(
        zone => zone.areaType === 'distribution',
      )

      if (key === 'enabledChannelLetterbox') {
        if (d2dDistributionZones.length) {
          error = false
        }
      }

      if (key === 'enabledChannelPreciseLocations') {
        if (h2hDistributionZones.length) {
          error = false
        }
      }
    }
  }

  return { error }
}

const checkIsFlyerPack = key => ['flyerPackH2h', 'flyerPackD2d'].includes(key)

export { formatCitiesSettings, checkIsFlyerPack, checkDistributionZonesInCity }
